import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


import { ConfigServerService, CustomHttp } from '../../../core';

@Injectable({
    providedIn: 'root'
})
export class UsuarioFileManagerService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/usuario`;
    }

    /** Exclui a imagem do avatar do usuário */
    deleteAvatar(id: number): Observable<string> {
        return this.customHttp.delete<string>(`${this.pathApi}/${id}/avatar`);
    }

    /** Exclui a imagem da assinatura de e-mail do usuário */
    deleteAssinaturaEmail(id: number): Observable<string> {
        return this.customHttp.delete<string>(`${this.pathApi}/${id}/upload/assinaturaemail`);
    }
}
